<div [formGroup]="DistrictCampusFormGroup">
  <!--District Filter-->
  @if (districtList.length) {
    <div class="match__messages">
      <div class="district__no__match">
        @if (prefilledDistrictName && !prefilledDistrictNameMatch) {
          <span>
            Scanned District: {{prefilledDistrictName}}
          </span>
        }
      </div>
      <div class="campus__no__match">
        @if (prefilledCampusName && !prefilledCampusNameMatch) {
          <span>
            Scanned Campus: {{prefilledCampusName}}
          </span>
        }
      </div>
    </div>
  }
  <mat-form-field [style.width]="districtWidth" [style.margin]="districtMargin">
    <mat-label>District</mat-label>
    <input type="text" matInput [matAutocomplete]="autoDistrict" formControlName="district" (ngModelChange)="setDistrict()" placeholder="Filter list by typing name">
    <mat-autocomplete style="width: auto !important;" #autoDistrict="matAutocomplete" [displayWith]="displayFnDistrict">
      @for (district of filteredDistrictOptions | async; track district) {
        <mat-option [value]="district">
          {{district.districtName}}
        </mat-option>
      }
    </mat-autocomplete>
    @if (isDistrictLoading) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    @if (DistrictCampusFormGroup.get('district').errors?.required) {
      <mat-error>
        District is required
      </mat-error>
    }
  </mat-form-field>

  <!--Campus Name Filter-->
  <mat-form-field [style.width]="campusWidth" [style.margin]="campusMargin">
    <mat-label>Campus</mat-label>
    <input type="text" matInput [matAutocomplete]="autoCampus" formControlName="campus" placeholder="Filter list by typing name">
    <mat-autocomplete style="width: auto !important;" #autoCampus="matAutocomplete" [displayWith]="displayFnCampus">
      @for (campus of filteredCampusOptions | async; track campus) {
        <mat-option [value]="campus">
          {{campus.name}}
        </mat-option>
      }
    </mat-autocomplete>
    @if (isCampusLoading) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    @if (DistrictCampusFormGroup.get('campus').errors?.required) {
      <mat-error>
        Campus is required
      </mat-error>
    }
  </mat-form-field>
</div>